import React from 'react';
import '../style/chart_legend.scss';
import { FormattedMessage } from 'react-intl';
import { ChartLegendItem } from './ChartLegendItem';
import { ChartLegendList } from './ChartLegendList';
import { decisionLabel, percentLabel } from './chartLegend.utils';
import { generateColorRange, mergeSlices } from '../chartsUtils';

type BaseProps = {
  data: Array<number>;
  labels: Array<string>;
  baseH: number;
  limit: number;
  handleClick?: (wantToOpenInNewTab: boolean, index: number) => void;
  onSeeMoreClicked: (
    event: React.MouseEvent<HTMLLIElement, MouseEvent>,
  ) => void;
};

const defaultProps = {
  handleClick: undefined, // eslint-disable-line react/default-props-match-prop-types
  onSeeMoreClicked: () => {}, // eslint-disable-line react/default-props-match-prop-types
  limit: 0, // eslint-disable-line react/default-props-match-prop-types
};

ChartDecisionLegend.defaultProps = defaultProps;
ChartPercentLegend.defaultProps = defaultProps;
ChartLegend.defaultProps = defaultProps;

export function ChartDecisionLegend(props: BaseProps) {
  return <ChartLegend {...props} labelFormater={decisionLabel} />;
}

export function ChartPercentLegend(props: BaseProps) {
  return <ChartLegend {...props} labelFormater={percentLabel} />;
}

type ChartLegendProps = BaseProps & {
  labelFormater: Function;
};

function ChartLegend(props: ChartLegendProps) {
  const { newData, newLabels } = mergeSlices({
    data: props.data,
    labels: props.labels,
  });
  const colors = generateColorRange({
    baseH: props.baseH,
    minSL: 20,
    maxSL: 80,
    nb: newData.length,
  });
  const truncateIndex = props.limit || 10;
  const { handleClick } = props;
  return (
    <div className="chart-legend">
      <ChartLegendList
        data={newData.slice(0, truncateIndex)}
        renderItems={items =>
          items.map(({ clickable, value, i }) => (
            <ChartLegendItem
              key={i}
              clickable={clickable && !!handleClick}
              handleClick={openInNewTab =>
                handleClick && handleClick(openInNewTab, i)
              }
              label={props.labelFormater(newLabels[i], value)}
              color={colors[i]}
            />
          ))
        }
      >
        {props.limit > 0 && (
          <li
            onClick={props.onSeeMoreClicked}
            className="chart-legend__see-more"
          >
            <FormattedMessage id="entity/charts/legend/ChartLegend.tsx/1" />
          </li>
        )}
      </ChartLegendList>
    </div>
  );
}
